module.exports = __webpack_public_path__ + "static/img/MC@3x.53f67916.jpg";